import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="border-t border-border bg-background py-4">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          
          {/* Left: Brand & Copyright */}
          <div className="flex flex-col items-center md:items-start gap-1">
            <Link to="/" className="flex items-center gap-2 group hover:opacity-80 transition-opacity duration-200">
              <div className="w-6 h-6">
                <img 
                  src="/logo-seul.svg" 
                  alt="Neuvième Continent logo" 
                  className="w-full h-full object-contain" 
                />
              </div>
              <span className="font-elegant text-sm font-bold text-foreground">
                Neuvième Continent
              </span>
            </Link>
            <span className="text-[10px] text-muted-foreground">
              © {new Date().getFullYear()} Neuvième Continent. Tous droits réservés.
            </span>
          </div>

          {/* Center: Legal Links */}
          <div className="flex flex-wrap justify-center gap-3 sm:gap-6">
            <Link to="/privacy-policy" className="text-xs text-muted-foreground hover:text-primary transition-colors">
              Politique de Confidentialité
            </Link>
            <Link to="/cookie-policy" className="text-xs text-muted-foreground hover:text-primary transition-colors">
              Politique de Cookies
            </Link>
            <button 
              onClick={() => window.dispatchEvent(new CustomEvent('open-cookie-settings'))}
              className="text-xs text-muted-foreground hover:text-primary transition-colors"
            >
              Paramètres des Cookies
            </button>
          </div>

          {/* Right: Social */}
          <div className="flex items-center">
            <a 
              href="https://discord.gg/rPJeDhgMjg" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-8 h-8 rounded-full bg-muted hover:bg-primary hover:shadow-md flex items-center justify-center transition-all duration-300 active:scale-95 group" 
              aria-label="Rejoignez notre serveur Discord"
            >
              <img 
                src="https://horizons-cdn.hostinger.com/257434f3-17c6-40ce-944a-86edaf1db41d/16a9465d27bbdadea715476e6817aaa9.png" 
                alt="Discord logo" 
                className="w-4 h-4 object-contain group-hover:brightness-200 transition-all duration-300" 
              />
            </a>
          </div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;